import * as React from 'react';
import { HoldingAreaHeader } from 'components/multi-item/holding-area-header';
import { UitkSheet } from 'uitk-react-sheet';

export interface ItemsPlaybackProps {
  itemCount?: number;
  linkTo: {
    pathname: string;
    search: string;
  };
  setToggleRef: (ref) => void;
  titleText: string;
}

export const ItemsPlayback = ({ itemCount, linkTo, setToggleRef, titleText }: ItemsPlaybackProps) => (
  <UitkSheet className="uitk-grid uitk-type-400 all-x-padding-three all-y-padding-three" isVisible={itemCount > 0}>
    <HoldingAreaHeader setToggleRef={setToggleRef} linkTo={linkTo} numberOfItems={itemCount} titleText={titleText} />
  </UitkSheet>
);
